export const TOTAL_SCREENS = 8;

export const screenConfig = [
  {
    id: 1,
    menuLabel: "Patient & Session Summary",
  },
  {
    id: 2,
    menuLabel: "How Do You Feel Today?",
  },
  {
    id: 3,
    menuLabel: "Rate Today's Therapy",
  },
  {
    id: 4,
    menuLabel: "Stress Level — Before & After",
  },
  {
    id: 5,
    menuLabel: "Today's Improvements",
  },
  {
    id: 6,
    menuLabel: "Therapy Experience",
  },
  {
    id: 7,
    menuLabel: "Ayurvedic Wellness Score",
  },
  {
    id: 8,
    menuLabel: "Patient Feedback & Report",
  },
];
